import { Box } from '@mui/material';
import styled from 'styled-components';

export const StyledMainProduct = styled(Box)`
  height: 126px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  width: 100%;
  margin-top: -4px;

  .image-wrapper {
    width: 164px;
    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  .stroked-wrapper {
    justify-content: center;
    width: 100%;
    height: 18px;

    .stroked {
      color: #fff;
      text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.8);
      font-family: var(--font-family), Arial;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
      text-decoration: line-through 2px #f02223;
    }
  }

  .quantity-wrapper {
    border-radius: 4px;
    justify-content: center;
    width: 100%;
    height: 33px;

    .quantity {
      font-family: Anton;
      font-size: 22px;
      font-style: normal;
      font-weight: 400;
      line-height: 33px;
      background: linear-gradient(180deg, #fffd4c 0%, #e9a913 100%);
      background-clip: text;
      font-family: var(--font-family), Arial;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
` as any;

export const StyledSubProduct = styled(Box)<{
  rightBorder: boolean;
  color: string;
}>`
  width: 71px;
  height: 34px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  border-right: ${({ rightBorder }) =>
    rightBorder ? '1px solid #57016F' : ''};

  img {
    display: flex;
    position: relative;
    z-index: 2;
    height: auto;
    width: 34px;
  }

  .quantity-wrapper {
    width: 25px;

    .div {
      width: 100%;

      .quantity {
        width: 100%;
        margin: 0;
        color: ${({ color }) => color};
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
  }
`;

export const StyledSubProductsContainer = styled(Box)`
  box-sizing: border-box;
  width: 331px;
  height: 92px;
  display: grid;
  grid-template-rows: 1fr;
  grid-auto-flow: column;
  overflow-x: hidden;
  padding: 4px;

  > div {
    display: flex;
    width: 100%;
    white-space: nowrap;
    justify-content: center;
    align-items: center;
    padding: 0;
    margin: 0;
  }

  .sub-items-grid {
    width: 321px;
    height: 76px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin: 4px auto;
  }
`;
